// extracted by mini-css-extract-plugin
export var content = "Stm4n";
export var decorationBottom = "d2h+y";
export var decorationTop = "xaHTD";